const Spinner = () => (
  <div
    style={{
      width: '24px',
      height: '24px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #007bff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    }}
  />
);

// Simple CSS-in-JS animation (you can also do this in CSS)
const spinnerStyle = document.createElement('style');
spinnerStyle.innerHTML = `
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`;
document.head.appendChild(spinnerStyle);

const ProgressBar = ({ percentage }) => (
  <div
    style={{
      border: '1px solid #ccc',
      width: '100%',
      height: '24px',
      marginTop: '10px',
    }}
  >
    <div
      style={{
        width: `${percentage}%`,
        height: '100%',
        backgroundColor: '#4caf50',
        transition: 'width 1s linear',
      }}
    />
  </div>
);

export { ProgressBar, Spinner };
